import { Controller } from '@hotwired/stimulus';

// Six-box one-time-code input: autofocus, auto-advance, backspace, paste.
// Keeps a hidden field (the real Devise `otp_code`) in sync.
//
// Usage:
//   <div data-controller="otp-input" data-action="paste->otp-input#paste">
//     <input data-otp-input-target="box"
//            data-action="input->otp-input#input keydown->otp-input#keydown"> x6
//     <input type="hidden" data-otp-input-target="hidden">
//   </div>
export default class extends Controller {
  static targets = ['box', 'hidden'];

  connect() {
    this.boxTargets[0]?.focus();
  }

  input(event) {
    const box = event.target;
    box.value = box.value.replace(/\D/g, '').slice(-1);
    box.classList.toggle('is-filled', box.value !== '');

    const index = this.boxTargets.indexOf(box);
    if (box.value && index < this.boxTargets.length - 1) {
      this.boxTargets[index + 1].focus();
    }
    this.sync();
  }

  keydown(event) {
    if (event.key !== 'Backspace') return;

    const box = event.target;
    const index = this.boxTargets.indexOf(box);
    if (!box.value && index > 0) this.boxTargets[index - 1].focus();
  }

  paste(event) {
    const max = this.boxTargets.length;
    const digits = (event.clipboardData.getData('text') || '')
      .replace(/\D/g, '')
      .slice(0, max);
    if (!digits) return;

    event.preventDefault();
    this.boxTargets.forEach((box, i) => {
      box.value = digits[i] || '';
      box.classList.toggle('is-filled', Boolean(digits[i]));
    });
    this.boxTargets[Math.min(digits.length, max - 1)].focus();
    this.sync();
  }

  sync() {
    this.hiddenTarget.value = this.boxTargets.map((box) => box.value).join('');
  }
}
